import { ReactElement } from 'react';
import { Body } from '@client/product/components/ProductActions/PDFAction/PDFForm/Body';
import { Formik } from 'formik';
import { Props } from './PDFForm.types';
import { FIELD_NAME } from './PDFFormContainer.types';

export const PDFForm = (props: Props): ReactElement => {
  const {
    product: { effectivePricing },
  } = props;

  const offerPrice = effectivePricing.hasB2BUserPrices
    ? effectivePricing.userPrice
    : effectivePricing.listPrice;

  return (
    <Formik
      initialValues={{
        [FIELD_NAME.additionalComments]: '',
        [FIELD_NAME.additionalImages]: true,
        [FIELD_NAME.description]: true,
        [FIELD_NAME.fixedPrices]: false,
        [FIELD_NAME.fixedPricesTaxValue]: effectivePricing.isHiddenPriceAndNotCertified
          ? []
          : [FIELD_NAME.listPrice],
        [FIELD_NAME.mainImage]: true,
        [FIELD_NAME.manufacturerNumber]: true,
        [FIELD_NAME.offer]: !effectivePricing.isHiddenPriceAndNotCertified,
        [FIELD_NAME.offerPriceValue]: offerPrice.toFixed(2),
        [FIELD_NAME.offerValue]: [FIELD_NAME.withVAT],
        [FIELD_NAME.productName]: true,
        [FIELD_NAME.shortInfo]: true,
        [FIELD_NAME.sku]: true,
        [FIELD_NAME.specification]: true,
        [FIELD_NAME.warrantyInfo]: true,
      }}
      onSubmit={() => undefined}
    >
      <Body {...props} />
    </Formik>
  );
};
